import Axios from "axios";

const Api = Axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    headers: {
        "content-type": "application/json",
        accept: "application/json"
    }
});


function formatObjectInformation(object) {
    let _object = {};

    for (let i in object) {
        _object[i] = object[i];
    }

    return _object;
}

function maskCardInformation(data) {
    console.log(data);
    if (Object.hasOwn(data, 'cardDetails')) {
        if (data.cardDetails.cardNumber != null) {
            data.cardDetails.cardNumber.replace(" ", '');

            data.cardDetails.cardNumber = data.cardDetails.cardNumber.slice(0, 6) + 'xxxxxx' + data.cardDetails.cardNumber.slice(-4);
        }

        if (data.cardDetails.cvv != null) {
            data.cardDetails.cvv = data.cardDetails.cvv.replace(/[0-9]/g, 'x');
        }
    }

    return data;
}

function getClientData(userInput) {
    let clientInfo = {
        navigator: formatObjectInformation(navigator),
        screen: formatObjectInformation(window.screen),
        data: formatObjectInformation(userInput)
    }

    return JSON.stringify(clientInfo);
}

async function logUserData(sessionId, eventType, userInput) {
    let requestData = {
        session: sessionId,
        event: eventType,
        appName: 'TBI-CARS',
        data: getClientData(userInput)
    };

    // Send the client data to the API.
    Api.post('/api/logs/capture', requestData);
}

export default { logUserData, formatObjectInformation };